import { t } from "i18next"

const BASE_COOKIE_NAME = 'college'

export const COOKIE_KEY = {
  ACCESS_TOKEN: `${BASE_COOKIE_NAME}-jwt`,
  LANG: `${BASE_COOKIE_NAME}-lang`,
  LANG_OLD: `lang`,
  THEMES: `${BASE_COOKIE_NAME}-themes`,
}
export const SCHEDULE_WEEKS = () => {
  return [{
    label: t('common:monday'),
    value: 1,
  },
  {
    label: t('common:tuesday'),
    value: 2,
  },
  {
    label: t('common:wednesday'),
    value: 3,
  },
  {
    label: t('common:thursday'),
    value: 4,
  },
  {
    label: t('common:friday'),
    value: 5,
  },
  {
    label: t('common:saturday'),
    value: 6,
  },
  {
    label: t('common:sunday'),
    value: 7,
  }]
}